import type { RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'
// import generatedRoutes from 'virtual:generated-pages'
// import { setupLayouts } from 'virtual:meta-layouts'
import { createRouter, createWebHashHistory } from 'vue-router'
import { isLogin } from '@/utils/auth'
import { menusRoutes } from './modules/root'
import 'nprogress/nprogress.css'

let routes: RouteRecordRaw[] = []

const routesContext: any = import.meta.glob('./modules/*.ts', { eager: true })
Object.keys(routesContext).forEach((v) => {
  routes.push(routesContext[v].default)
})
routes.push({
  path: '/:pathMatch(.*)*',
  component: () => import('@/views/[...all].vue'),
  meta: {
    title: '找不到页面',
  },
})
routes = routes.flat()

// generatedRoutes.forEach((v) => {
//   routes.push(v?.meta?.layout !== false ? setupLayouts([v])[0] : v)
// })

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

const whiteList = ['/login']

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()
  NProgress.start()
  if (isLogin()) {
    if (to.path === '/login') {
      next({ path: '/home' })
    }
    else {
      if (userStore.userInfo?.role) {
        if (userStore.userRoutes.length === 0) {
          menusRoutes.forEach((route) => {
            if (route.meta?.roles && Array.isArray(route.meta.roles) && route.meta.roles.includes(userStore.userInfo?.role)) {
              // 根据角色显示对应菜单
              userStore.userRoutes.push({
                name: route.meta.title,
                path: route.path,
                menuPath: route.meta.menuPath,
                hiddenActivePath: route.meta.hiddenActivePath,
              })
              // 根据角色动态添加路由
              router.addRoute(route)
            }
          })
          next({ ...to, replace: true })
        }
        else {
          next()
        }
      }
      else {
        userStore.logout()
      }
    }
  }
  else {
    if (whiteList.includes(to.path)) {
      next()
    }
    else {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath,
        },
      })
    }
  }
})

router.afterEach((to) => {
  NProgress.done()
  useSettingsStore().setTitle(to.meta.title ?? '')
})

export default router
